import { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import axios from "axios";
import { FaSpinner } from "react-icons/fa";
import { hideModal, showModal } from "../../utils/modalUtility";
import Pagination from "../common/pagination";

function Gallery() {
  const [media, setMedia] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [activeTab, setActiveTab] = useState("link"); // link | local

  // const [uploadedFile, setUploadedFile] = useState(null); // for file input
  const [uploadedFile, setUploadedFile] = useState([]);

  const axiosAPI = useAxios();

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [formData, setFormData] = useState({
    mediaName: "",
    mediaType: "",
    mediaUrl: "",
    thumbnailUrl: "",
  });

  const removeFormData = () => {
    setFormData({
      mediaName: "",
      mediaType: "",
      mediaUrl: "",
      thumbnailUrl: "",
    });
  };

  const [filters, setFilters] = useState({
    status: "",
    from_date: "",
    to_date: "",
  });

  // Handler to update filters
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Get All Notifications
  const getMedia = async () => {
    try {
      const response = await axiosAPI.get(`/api/media?page=${page}`);
      //   console.log(response.data.data);
      setMedia(response.data.data);
      setTotalPages(response?.data?.totalPages);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handlePageClick = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setPage(pageNum);
    }
  };

  // Handle Input Changes
  // const handleChange = (e) => {
  //   console.log(e.target.id, e.target.value);
  //   setFormData({ ...formData, [e.target.id]: e.target.value });
  // };

  const handleChange = (e) => {
    const { id, value, files, type } = e.target;

    if (type === "file") {
      // setUploadedFile(files[0]); //  store separately
      // setUploadedFile([...files]); // store all files
      // store all selected files as an array
      setUploadedFile(Array.from(files));
    } else {
      setFormData((prev) => ({
        ...prev,
        [id]: value,
      }));
    }
  };

  // Handle Submit (Add or Edit)
  const handleSubmit = async (e) => {
    e.preventDefault();

    // ======================
    // COMMON VALIDATION
    // ======================
    if (!formData.mediaType) {
      return window.notifyMessage(
        "Validation Error",
        "Please select media type",
        "warning",
      );
    }

    // ======================
    // TAB BASED VALIDATION
    // ======================
    if (activeTab === "link" && !formData.mediaUrl?.trim()) {
      return window.notifyMessage(
        "Validation Error",
        "Media URL is required",
        "warning",
      );
    }

    if (
      activeTab === "local" &&
      (!uploadedFile || uploadedFile.length === 0) &&
      !formData.file_path
    ) {
      return window.notifyMessage(
        "Validation Error",
        "Please upload at least one file",
        "warning",
      );
    }

    setIsLoading(true);

    try {
      const formPayload = new FormData();

      // ====== MEDIA NAME LOGIC ======
      if (activeTab === "local" && uploadedFile && uploadedFile.length > 0) {
        // Use first file name for media_name (or custom logic)
        const fileNameWithoutExt = uploadedFile[0].name.replace(
          /\.[^/.]+$/,
          "",
        );
        formPayload.append("media_name", fileNameWithoutExt);
      } else if (activeTab === "link") {
        // Link upload -> random name
        const randomName = `media_${Date.now()}`;
        formPayload.append("media_name", randomName);
      } else {
        // fallback (edit mode without changing file)
        formPayload.append("media_name", formData.mediaName?.trim() || "");
      }

      formPayload.append("media_type", formData.mediaType);

      if (activeTab === "link") {
        formPayload.append("media_url", formData.mediaUrl?.trim() || "");
        formPayload.append(
          "thumbnail_url",
          formData.thumbnailUrl?.trim() || "",
        );
      } else if (activeTab === "local") {
        if (uploadedFile && uploadedFile.length > 0) {
          uploadedFile.forEach((file) => {
            formPayload.append("files", file); // append each file
          });
        }
      }

      // console.log("Form Payload:");
      // for (let pair of formPayload.entries()) {
      //   console.log(pair[0] + ": " + pair[1]);
      // }

      // return;

      let response;
      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/media/${currentUserId}`,
          formPayload,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        window.notifyMessage(
          "Success",
          "Media updated successfully",
          "success",
        );
      } else {
        response = await axiosAPI.post("/api/media/add-media", formPayload, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        window.notifyMessage("Success", "Media added successfully", "success");
      }
      hideModal("newGalleryModal");
      getMedia();
      removeFormData();
      setIsEditMode(false);

      // window.location.reload(); // Reload page to reflect changes in the Property list
      closeModal();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    } finally {
      setIsLoading(false);
    }
  };

  // Edit Modal Open
  const openEditModal = (id) => {
    setCurrentUserId(id);
    // console.log(id);

    // Find the notification with this ID and populate the form
    const selectedMedia = media.find((media) => media.id === id);

    if (!selectedMedia) return;

    // console.log("Open edit modal", selectedMedia);
    if (selectedMedia) {
      setFormData({
        mediaName: selectedMedia.media_name,
        mediaType: selectedMedia.media_type,
        mediaUrl: selectedMedia.media_url,
        thumbnailUrl: selectedMedia.thumbnail_url,
      });
    }

    // Decide which tab to show
    if (selectedMedia.media_url) {
      setActiveTab("link");
      setUploadedFile(null);
    } else {
      setActiveTab("local");
      setUploadedFile(selectedMedia.file_path ? selectedMedia.file_path : null);
    }

    setIsEditMode(true);
    showModal("newGalleryModal");
  };

  // console.log(enquiries)

  const handleDelete = async (id) => {
    console.log(id);
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/media/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      getMedia();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger",
      );
    }
  };

  // Close Modal
  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  const openAddModal = () => {
    showModal("newGalleryModal");
  };

  useEffect(() => {
    if (activeTab === "link") {
      // Clear uploaded file only
      setUploadedFile(null);
    }

    // Do NOT clear mediaUrl / thumbnailUrl on local tab
    // Let formData remain intact
  }, [activeTab]);
  // console.log(statusList);

  useEffect(() => {
    getMedia();
  }, [page]);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openAddModal()}
            >
              Add Gallery Item
            </button>
          </div>
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id="newGalleryModal"
          tabIndex="-1"
          aria-labelledby="newGalleryModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newGalleryModalLabel">
                  {isEditMode ? "Edit Gallery" : "Add Gallery"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>

              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Property Name (Input Field) */}
                  <div className="mb-3">
                    <label htmlFor="mediaName" className="form-label">
                      Media Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="mediaName"
                      placeholder="Enter media name"
                      value={formData.mediaName}
                      onChange={handleChange}
                      // required
                    />
                  </div>

                  {/* Select Property */}
                  <div className="mb-3">
                    <label htmlFor="mediaType" className="form-label">
                      Select Media Type
                    </label>
                    <select
                      className="form-select"
                      id="mediaType"
                      name="mediaType"
                      required
                      value={formData.mediaType}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select Media Type
                      </option>

                      <option value="image">Image</option>
                      <option value="video">Video</option>
                    </select>
                  </div>

                  {/* Nav Tabs */}
                  <ul className="nav nav-tabs mb-3">
                    <li className="nav-item">
                      <button
                        type="button"
                        className={`nav-link ${activeTab === "link" ? "active" : ""}`}
                        onClick={() => setActiveTab("link")}
                      >
                        Upload via Link
                      </button>
                    </li>

                    <li className="nav-item">
                      <button
                        type="button"
                        className={`nav-link ${activeTab === "local" ? "active" : ""}`}
                        onClick={() => setActiveTab("local")}
                      >
                        Upload Locally
                      </button>
                    </li>
                  </ul>

                  {activeTab === "link" && (
                    <>
                      <div className="mb-3">
                        <label htmlFor="mediaUrl" className="form-label">
                          Media Url
                        </label>
                        <textarea
                          className="form-control"
                          id="mediaUrl"
                          placeholder="Enter your media URL"
                          value={formData.mediaUrl}
                          onChange={handleChange}
                          rows={3}
                          required
                        ></textarea>
                      </div>

                      <div className="mb-3">
                        <label htmlFor="thumbnailUrl" className="form-label">
                          Thumbnail Url
                        </label>
                        <textarea
                          className="form-control"
                          id="thumbnailUrl"
                          placeholder="Enter your thumbnail URL"
                          value={formData.thumbnailUrl}
                          onChange={handleChange}
                          rows={3}
                        ></textarea>
                      </div>
                    </>
                  )}

                  {/* Upload Locally */}
                  {activeTab === "local" && (
                    <div className="mb-3">
                      <label className="form-label">
                        Upload (Image or Video)
                      </label>
                      <input
                        type="file"
                        {...(!isEditMode && { multiple: true })} // multiple allowed only in add mode
                        className="form-control"
                        id="mediaFile"
                        name="files"
                        accept="image/*,video/*"
                        onChange={handleChange}
                        required
                      />
                    </div>
                  )}

                  <p className="text-danger mb-3">
                    Note: Only images (jpeg, png, gif, webp) up to 5MB and video
                    files are allowed.
                  </p>

                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                    disabled={isLoading} // Disable button while isLoading
                  >
                    {isLoading ? (
                      <FaSpinner className="spinner" spin /> // Loader icon from react-icons
                    ) : isEditMode ? (
                      "Update Gallery"
                    ) : (
                      "Add Gallery"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Notification Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                {/* Left Section - User Details */}
                <div className="d-flex align-items-center">
                  <h4 className="card-title mb-0">
                    All Media ({media?.length} )
                  </h4>
                </div>

                {/* Right Section - Filters */}
                {/* <div className="d-flex gap-3 flex-wrap ">
                  Status Dropdown
                  <div
                    className="d-flex flex-column"
                    style={{ minWidth: "180px" }}
                  >
                    <label className="form-label mb-1">Status</label>
                    <select
                      className="form-select"
                      value={filters.status}
                      onChange={(e) =>
                        handleFilterChange("status", e.target.value)
                      }
                      style={{ width: "100%" }}
                    >
                      <option value="">All Status</option>
                      <option value="new">New</option>
                      <option value="follow_up">Follow Up</option>
                      <option value="interested">Interested</option>
                    </select>
                  </div>

                  From Date
                  <div className="d-flex flex-column">
                    <label htmlFor="fromDate" className="form-label mb-1">
                      From
                    </label>
                    <input
                      id="fromDate"
                      type="date"
                      className="form-control"
                      value={filters.from_date || ""}
                      onChange={(e) =>
                        handleFilterChange("from_date", e.target.value)
                      }
                    />
                  </div>

                  To Date
                  <div className="d-flex flex-column">
                    <label htmlFor="toDate" className="form-label mb-1">
                      To
                    </label>
                    <input
                      id="toDate"
                      type="date"
                      className="form-control"
                      value={filters.to_date || ""}
                      onChange={(e) =>
                        handleFilterChange("to_date", e.target.value)
                      }
                    />
                  </div>

                  Filter Button
                  <div className="d-flex align-items-center">
                    <button
                      className="btn btn-primary rounded-pill px-4 mt-2 mt-md-4"
                      style={{ height: "38px" }}
                      onClick={() => {
                        if (
                          filters.status ||
                          filters.from_date ||
                          filters.to_date
                        ) {
                          getLeads();
                        } else {
                          alert("Please select both From and To dates.");
                        }
                      }}
                    >
                      Filter
                    </button>
                  </div>
                </div> */}
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Media Name</th>
                        <th>Media Url</th>
                        <th>Thumbnail Url</th>
                        <th>Media type</th>
                        <th>Created At</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        // Show a loading state when data is being fetched
                        <tr>
                          <td colSpan="9" className="text-center">
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : media.length == 0 ? (
                        // Show a "No Data Found" message when no data is available
                        <tr>
                          <td colSpan="6" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        // Render the list of leads if data is available
                        media.map((media) => {
                          const formattedDate = new Date(
                            media.created_at,
                          ).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          });

                          //   Check if the message length is greater than 50 characters and truncate it
                          const truncatedMessage =
                            media?.media_url?.length > 50
                              ? media.media_url.slice(0, 50) + "..."
                              : media.media_url;
                          const truncatedThumbnailMessage =
                            media.thumbnail_url?.length > 50
                              ? media.thumbnail_url.slice(0, 50) + "..."
                              : media.thumbnail_url;

                          return (
                            <tr key={media.id}>
                              <td>{media.media_name}</td>
                              <td>{truncatedMessage}</td>
                              <td>{truncatedThumbnailMessage}</td>
                              <td>{media.media_type}</td>
                              <td>{formattedDate}</td>
                              <td>
                                <a
                                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                  href={media.file_path}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i className="fa fa-link"></i>
                                </a>
                                <button
                                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                  onClick={() => openEditModal(media.id)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                  onClick={() => handleDelete(media.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Gallery;
